export default "__VITE_PUBLIC_ASSET__81477dca__"